<div>
    <nav
        class="sidebar fixed bottom-0 z-40 transition-all duration-300 bg-[#214A7B]"
        [ngClass]="isCollapsed ? 'lg:w-[70px] w-[260px]' : 'w-[260px]'"
        [ngStyle]="sidebarStyle">
        <div class="h-full bg-transparent relative">
            <!-- Collapse Button -->
            <button type="button"
                class="absolute -right-3 top-[72px] z-50 hidden lg:flex items-center justify-center w-6 h-6 rounded-full bg-white shadow-md hover:shadow-lg transition-all duration-200"
                (click)="toggleSidebar()"
                title="Réduire le menu">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#214A7B] transition-transform duration-200"
                    [ngClass]="isCollapsed ? 'rotate-180' : ''"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>

            <!-- body Section -->
            <ng-scrollbar class="relative h-full flex flex-col justify-between" appearance="compact">

                <ul class="p-3 pt-3 space-y-0.5 font-medium">

                    <li *ngFor="let item of menuItems" [hidden]="item.hide">
                        <!-- Section headers -->
                        <ng-container *ngIf="item.isHeader">
                            <h2 class="pl-2 pb-1.5 text-[10px] font-semibold tracking-wider text-white uppercase"
                                [ngClass]="isCollapsed ? 'pt-4' : 'pt-3'">
                                <span *ngIf="!isCollapsed">{{ (item.label) || '&nbsp;' }}</span>
                                <span *ngIf="isCollapsed">&nbsp;</span>
                            </h2>
                        </ng-container>

                        <!-- Menu items with submenu -->
                        <ng-container *ngIf="!item.isHeader && item.submenu && item.submenu.length > 0">
                            <button type="button"
                                class="flex items-center justify-between w-full px-2 py-2 rounded-lg transition-colors duration-200"
                                [ngClass]="{ 'bg-white text-[#214A7B]': hasActiveSubmenuItem(item), 'text-white hover:bg-white/20': !hasActiveSubmenuItem(item) }"
                                (click)="!isLoading && toggleAccordion(item.id)">
                                <div class="flex items-center">
                                    <span class="inline-flex items-center justify-center w-7 h-7 mr-2 rounded-md bg-white">
                                        <img class="w-4 h-4"
                                            [src]="'/assets/images/sidebar-icon/' + item.icon + '.svg'"
                                            [alt]="item.label + ' icon'" />
                                    </span>
                                    <span *ngIf="!isCollapsed" class="text-[13px] leading-tight whitespace-normal">{{ item.label }}</span>
                                </div>
                                <svg *ngIf="!isCollapsed"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-3.5 h-3.5 transition-transform duration-200"
                                    [ngClass]="hasActiveSubmenuItem(item) ? 'text-[#214A7B]' : 'text-white/80'"
                                    [class.transform]="activeDropdown.includes(item.id)"
                                    [class.rotate-90]="activeDropdown.includes(item.id)"
                                    viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </button>

                            <!-- submenu -->
                            <div *ngIf="activeDropdown.includes(item.id) && !isCollapsed" class="mt-0.5 ml-9 space-y-0.5">
                                <a *ngFor="let subItem of item.submenu" [routerLink]="subItem.link"
                                    [ngClass]="{'text-white font-medium': isRouteActive(subItem.link), 'text-white/70': !isRouteActive(subItem.link)}"
                                    class="block pl-2 py-1.5 text-[12px] hover:text-white transition-colors duration-200"
                                    (click)="!isLoading && onSubmenuItemClick(item.id)">
                                    <span class="block">{{ subItem.label }}</span>
                                </a>
                            </div>
                        </ng-container>

                        <!-- Single menu items without submenu -->
                        <ng-container *ngIf="!item.isHeader && !item.submenu">
                            <a [routerLink]="item.disabled ? null : item.link"
                                class="flex items-center px-2 py-2 rounded-lg transition-colors duration-200"
                                [ngClass]="{
                                    'bg-white text-[#214A7B]': isRouteActive(item.link) && !item.disabled,
                                    'text-white hover:bg-white/20': !isRouteActive(item.link) && !item.disabled,
                                    'text-white/40 cursor-not-allowed': item.disabled,
                                    'justify-center': isCollapsed
                                }"
                                (click)="item.disabled ? $event.preventDefault() : toggleMobileMenu()"
                                [title]="isCollapsed ? item.label : ''">
                                <div class="flex items-center" [ngClass]="isCollapsed ? '' : 'w-full'">
                                    <span class="inline-flex items-center justify-center w-7 h-7 rounded-md shrink-0"
                                        [ngClass]="[isCollapsed ? '' : 'mr-2', item.disabled ? 'bg-white/40' : 'bg-white']">
                                        <img [ngStyle]="{'width': '16px', 'height': '16px', 'opacity': item.disabled ? '0.4' : '1'}"
                                            [src]="'/assets/images/sidebar-icon/' + item.icon + '.svg'"
                                            [alt]="item.label + ' icon'" />
                                    </span>
                                    <span *ngIf="!isCollapsed" class="text-[13px] leading-tight whitespace-normal">{{ item.label }}</span>
                                </div>
                            </a>
                        </ng-container>
                    </li>
                </ul>

                <!-- Version indicator + Déconnexion-->
                <div class="w-full py-2 px-3">
                    <a class="flex items-center px-2 py-2 rounded-lg text-white hover:bg-white/20 cursor-pointer transition-colors duration-200"
                        [ngClass]="isCollapsed ? 'justify-center' : ''"
                        [title]="isCollapsed ? 'Déconnexion' : ''"
                        (click)="!isLoading && logout()">
                        <div class="flex items-center" [ngClass]="isCollapsed ? '' : 'w-full'">
                            <span class="inline-flex items-center justify-center w-7 h-7 rounded-md bg-white"
                                [ngClass]="isCollapsed ? '' : 'mr-2'">
                                <icon-logout *ngIf="!isLoading" class="h-4 w-4 shrink-0 rotate-90 text-[#214A7B]" />
                                <svg *ngIf="isLoading" class="animate-spin h-4 w-4 text-[#214A7B]" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                            </span>
                            <span *ngIf="!isCollapsed" class="text-[13px]">Déconnexion</span>
                        </div>
                    </a>
                    <div *ngIf="!isCollapsed" class="flex items-center justify-center">
                        <span class="font-inter text-[10px] font-medium text-white/50">
                            Version: {{ appVersion }}
                        </span>
                    </div>
                </div>

            </ng-scrollbar>
        </div>
    </nav>
</div>
